<template>
  <div class="usermsg">
    <row type="flex" justify="space-around">
      <i-col span="12" class="itemStyle">
        <div class="title"><Icon type="md-person" />用户名：</div>
        <div class="content">{{ userMsg.username }}</div>
      </i-col>
      <i-col span="12" class="itemStyle">
        <div class="title"><Icon type="md-ribbon" />会员等级：</div>
        <div class="content">{{ userMsg.memberNm }}</div>
      </i-col>
      <i-col span="12" class="itemStyle">
        <div class="title"><Icon type="md-flash" />用户昵称：</div>
        <div class="content" v-if="userMsg.nickname === ''">暂无</div>
        <div class="content">{{ userMsg.nickname }}</div>
      </i-col>
      <i-col span="12" class="itemStyle">
        <div class="title"><Icon type="md-call" />用户手机号：</div>
        <div class="content">
          {{ replaceStr(userMsg.phoneNumber) }}
        </div>
      </i-col>
    </row>
  </div>
</template>
<script>
export default {
  computed: {
    userMsg: {
      get() {
        return this.$store.state.userMsg;
      },
      set(userMsg) {
        this.$store.dispatch("commitUserMsg", userMsg);
      }
    }
  },
  methods: {
    replaceStr(str) {
      return str.replace(str.substr(3, 4), "*".repeat(4));
    }
  }
};
</script>

<style lang="less" scoped>
.usermsg {
  text-align: center;
  padding: 30px 10px;
  width: 100%;
  min-height: 100px;
  .itemStyle {
    text-align: left;

    padding: 10px 0;
    .title {
      font-weight: bold;
      font-size: 17px;
      i {
        font-size: 22px;
        margin-right: 6px;
        color: #2b85e4;
      }
    }
    .content {
      padding: 10px 0;
      padding-left: 30px;
      font-size: 16px;
    }
  }
}
</style>
